<body>
  <div class="grid-overlay">
    <app-page-header>
      <button class="header-action-btn" (click)="goBack()">{{ 'common.back' | translate }}</button>
    </app-page-header>
    <form [formGroup]="form" class="needs-validation">
      <div class="plans-data">
        <div class="second-headboard">
          <h1>{{ 'planForm.title' | translate }}</h1>
        </div>
        <div class="plans-data-text">
          <strong>{{ 'planForm.subtitle' | translate }}</strong>
          <p class="line-spacing">{{ 'planForm.description' | translate }}</p>
        </div>
        <div class="preview-text">
          <img src="../../../assets/icons/ver.png" alt="vista previa">
          <p class="text-right">{{ 'planForm.preview' | translate }}</p>
        </div>
        <div class="grid">
          <div class="create-first-plan">
            <h1>{{ 'updatePlan.createFirstPlan' | translate }}</h1>
            <div class="second-grid">
              <div class="upper-part">
                <div class="left">
                  <div class="items">
                    <div>
                      <label for="type">{{ 'planForm.fields.type' | translate }}</label>
                      <i class="material-icons icon-help" [matTooltip]="'planForm.fields.typeTooltip' | translate">help_outline</i>
                    </div>
                    <select id="type" [formControl]="form.controls['type']" tabindex="2" required>
                      <option [ngValue]="PlanType.LINK_DE_PAGO">{{ 'planForm.options.linkPayment' | translate }}</option>
                      <option [ngValue]="PlanType.NORMAL">{{ 'planForm.options.normal' | translate }}</option>
                      <option [ngValue]="PlanType.VARIABLE" [disabled]="isVariableBlockedBySubscribers">{{ 'planForm.options.variable' | translate }}</option>
                      <option [ngValue]="PlanType.ON_DEMAND" [disabled]="true">{{ 'planForm.options.onDemand' | translate }}</option>
                    </select>
                    <i class="arrow"></i>
                    @if (form.controls['type'].hasError('required') && form.controls['type'].touched) {
                      <small class="form-error-msg"> {{ 'planForm.fields.typeError' | translate }} </small>
                    }
                    @if (isVariableBlockedBySubscribers) {
                      <small class="form-info-msg">{{ 'updatePlan.variableBlockedBySubscribers' | translate }}</small>
                    }
                  </div>
                  <div class="items">
                    <div>
                      <label for="name">{{ 'planForm.fields.planName' | translate }}</label>
                      <i class="material-icons icon-help" [matTooltip]="'planForm.fields.planNameTooltip' | translate">help_outline</i>
                    </div>
                    <input [formControl]="form.controls['name_plan']" tabindex="1" required type="text" [placeholder]="'planForm.fields.planNamePlaceholder' | translate">
                    @if (form.controls['name_plan'].hasError('required') && form.controls['name_plan'].touched) {
                      <small class="form-error-msg">{{ 'planForm.fields.planNameError' | translate }}</small>
                    }
                  </div>
                  @if (!isVariable && !isOnDemand) {
                    <div class="items">
                      <div>
                        <label for="cost">{{ 'planForm.fields.cost' | translate }}</label>
                        <i class="material-icons icon-help" [matTooltip]="'planForm.fields.costTooltip' | translate">help_outline</i>
                      </div>
                      <input [formControl]="form.controls['feeCost_plan']" tabindex="3" type="number" required [placeholder]="'planForm.fields.costPlaceholder' | translate">
                      @if (form.controls['feeCost_plan'].hasError('required') && form.controls['feeCost_plan'].touched) {
                        <small class="form-error-msg">{{ 'planForm.fields.costError' | translate }}</small>
                      }
                    </div>
                  }
                  @if (!isVariable && !isOnDemand) {
                    <div class="items">
                      <div>
                        <label for="cost-per-freeze">{{ 'planForm.fields.enrollmentCost' | translate }}</label>
                        <i class="material-icons icon-help" [matTooltip]="'planForm.fields.enrollmentCostTooltip' | translate">help_outline</i>
                      </div>
                      <input [formControl]="form.controls['enrollmentCost_plan']" tabindex="5" type="number" required [placeholder]="'planForm.fields.enrollmentCostPlaceholder' | translate">
                      @if (form.controls['enrollmentCost_plan'].hasError('required') && form.controls['enrollmentCost_plan'].touched) {
                        <small class="form-error-msg">{{ 'planForm.fields.enrollmentCostError' | translate }}</small>
                      }
                    </div>
                  }
                  @if (!isVariable && !isOnDemand) {
                    <div class="items">
                      <div>
                        <label for="cost-per-freeze">{{ 'planForm.fields.freezeCost' | translate }}</label>
                        <i class="material-icons icon-help" [matTooltip]="'planForm.fields.freezeCostTooltip' | translate">help_outline</i>
                      </div>
                      <input [formControl]="form.controls['freezeCostPlan']" tabindex="6" type="number" required [placeholder]="'planForm.fields.freezeCostPlaceholder' | translate">
                      @if (form.controls['freezeCostPlan'].hasError('required') && form.controls['freezeCostPlan'].touched) {
                        <small class="form-error-msg">{{ 'planForm.fields.freezeCostError' | translate }}</small>
                      }
                    </div>
                  }
                </div>
                <div class="right">
                  @if (!isVariable && !isOnDemand) {
                    <div class="items">
                      <div>
                        <label for="tax">{{ 'planForm.fields.tax' | translate }}</label>
                        <i class="material-icons icon-help" [matTooltip]="'planForm.fields.taxTooltip' | translate">help_outline</i>
                      </div>
                      <input [formControl]="form.controls['taxRate_plan']" tabindex="4" type="number" [placeholder]="'planForm.fields.taxPlaceholder' | translate">
                      @if (form.controls['taxRate_plan'].hasError('required') && form.controls['taxRate_plan'].touched) {
                        <small class="form-error-msg">{{ 'planForm.fields.taxError' | translate }}</small>
                      }
                    </div>
                  }
                  @if (!isOnDemand) {
                    <div class="items">
                      <div>
                        <label for="frequency">{{ 'planForm.fields.frequency' | translate }}</label>
                        <i class="material-icons icon-help" [matTooltip]="'planForm.fields.frequencyTooltip' | translate">help_outline</i>
                      </div>
                      <select [formControl]="form.controls['frecuency']" tabindex="5" required (change)="onChangeFrecuency($event.target.selectedIndex)">
                        <option disabled selected value="">{{ 'updatePortal.generalData.selectOption' | translate }}</option>
                        @for (f of frecuencies; track f) {
                          <option [value]="f.id">{{ f.name_frecuency | dynamicTranslate }}</option>
                        }
                      </select>
                      <i class="arrow"></i>
                      @if (form.controls['frecuency'].hasError('required') && form.controls['frecuency'].touched) {
                        <small class="form-error-msg">{{ 'planForm.fields.frequencyError' | translate }}</small>
                      }
                    </div>
                  }
                  @if (!isOnDemand) {
                    <div class="items">
                      <div>
                        <label for="qty_installments_to_collect_plan">{{ 'planForm.fields.installments' | translate }}</label>
                        <i class="material-icons icon-help" matTooltip="Se refiere a la cantidad de cuotas que se cobrará en el plan.">help_outline</i>
                      </div>
                      <select [formControl]="form.controls['qty_installments_to_collect_plan']" tabindex="7">
                        <option disabled>{{ 'updatePortal.generalData.selectOption' | translate }}</option>
                        <option value="0" selected>{{ 'planForm.fields.noApply' | translate }}</option>
                        <option [ngValue]="1">1 Cuota</option>
                        @for (i of [].constructor(47); track i; let index = $index) {
                          <option [ngValue]="index + 2">{{ index + 2 }} Cuotas</option>
                        }
                      </select>
                      <i class="arrow"></i>
                    </div>
                  }
                  @if (!isVariable && !isOnDemand) {
                    <div class="items">
                      <div>
                        <label for="is_visible_plan">{{ 'planForm.fields.visibility' | translate }}</label>
                        <i class="material-icons icon-help" matTooltip="Se refiere a si el plan es visible o no.">help_outline</i>
                      </div>
                      <select [formControl]="form.controls['is_visible_plan']" tabindex="8" required>
                        <option value="" disabled selected>{{ 'updatePortal.generalData.selectOption' | translate }}</option>
                        <option [value]="true">{{ 'planForm.fields.yes' | translate }}</option>
                        <option [value]="false">{{ 'planForm.fields.no' | translate }}</option>
                      </select>
                      <i class="arrow"></i>
                      @if (form.controls['is_visible_plan'].hasError('required') && form.controls['is_visible_plan'].touched) {
                        <small class="form-error-msg">{{ 'planForm.fields.visibilityError' | translate }}</small>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="shared-part">
                <div class="items">
                  <label for="description">{{ 'planForm.fields.description' | translate }}</label>
                  <textarea [formControl]="form.controls['description']" tabindex="10" rows="3" type="text" [placeholder]="'planForm.fields.descriptionPlaceholder' | translate"></textarea>
                  @if (form.controls['description'].hasError('required') && form.controls['description'].touched) {
                    <small class="form-error-msg">{{ 'planForm.fields.descriptionError' | translate }}</small>
                  }
                </div>
              </div>
              @if (!isVariable && !isOnDemand) {
                <div class="bottom">
                  <div class="left">
                    <div class="items">
                      <label for="image">{{ 'planForm.fields.coverImage' | translate }}</label>
                      <div class="upload-photo">
                        <div class="first-part">
                          <input tabindex="9" #inputFile class="form-control" type="file" id="formFile" accept="image/png, image/jpeg, image/svg" (change)="onLogoChange($event)">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="preview-text2">
            <img src="../../../assets/icons/ver.png" alt="vista previa">
            <p>{{ 'planForm.preview' | translate }}</p>
          </div>
          <div class="preview">
            <h1>{{ (form.controls['name_plan'].value || 'Primer plan') | dynamicTranslate }}</h1>
            <div class="see-photo">
              <img [src]="image64 || imageTemp" alt="foto">
            </div>
            <h3>{{ 'Beneficio principal' | dynamicTranslate }}</h3>
            <h1 class="big-number">${{ form.controls['feeCost_plan'].value || '0' }}</h1>
            <h3>{{ (frecuencyName || 'Mensuales') | dynamicTranslate }}</h3>
            <div class="including">
              <h3 class="dotted-list">
                <li>{{(this.form.controls["description"].value) | dynamicTranslate}}</li>
              </h3>
            </div>
            <button>{{ 'Seleccionar' | dynamicTranslate }}</button>
          </div>
        </div>
        <div class="save">
          <button tabindex="11" (click)="send()">{{ 'updatePlan.save' | translate }}</button>
        </div>
      </div>
    </form>
    <div class="options-buttons">
      <button class="back-btn" (click)="goBack()">{{ 'updatePlan.back' | translate }}</button>
    </div>
  </div>
</body>
